import { LOADER_SVG } from "src/constants/svg-paths";
interface LoaderProps {
  noDataLoaderClassName?: string;
}

const Loader = ({ noDataLoaderClassName }: LoaderProps) => (
  <div className={`loader-wrapper ${noDataLoaderClassName}`}>
    <div className="loader">
      <img src={LOADER_SVG} alt="" />
      <h6>LOADING</h6>
    </div>
  </div>
);
export default Loader;
